import { App } from "./App";
import { config } from "./game/consts/config";

(() => {
    const template = document.getElementById('game-instance-template');
    if (!template) throw new Error("No template");
    template.parentElement?.removeChild(template);
    const game_screens = document.getElementById('games-screens');
    if (!game_screens) throw new Error("No Game Screens");
    for (let i = 0; i < config.players; ++i) {
        const node = template.cloneNode(true) as HTMLDivElement;
        node.removeAttribute('id');
        game_screens.append(node);
    }

    const app = new App();
    app.run();
})();